export const userProfile = {
  alumno: {
    extBecario: '121',
    extAspirante: '122',
    extMaquinista: '123',
    intBecario: '112',
    intMaquinista: '111',
  },
  instructor: '211',
  formador: '311',
  gestor: '411',
  administrador: '511',
  supervisor: '611',
  visualizador: '711',
};
export const perfilesAlumno = [
  userProfile.alumno.extAspirante,
  userProfile.alumno.extBecario,
  userProfile.alumno.extMaquinista,
  userProfile.alumno.intBecario,
  userProfile.alumno.intMaquinista,
];
